import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

import HeaderBack from "@/components/dashboard/Header/HeaderBack";
import MotionText from '@/components/common/Motion/MotionText';
import MotionDiv from '@/components/common/Motion/MotionDiv';
import MotionImage from '@/components/common/Motion/MotionImage';

import {
  PiMagnifyingGlass,
  PiCar
} from 'react-icons/pi';

import Button from '@/components/common/Button/Button';
import DocumentNumberVisual from '@assets/visuals/document-number-visual.webp';
import { usePageSetup } from '@/hooks/usePageSetup';

export const ExpensesDocumentInfoPage = () => {
  const { t } = useTranslation();
  usePageSetup(t('expenses.pageTitle.documentInfo'))
  const navigate = useNavigate();

  return (
    <div className="h-full bg-white flex flex-col">
      <HeaderBack />
      <div className="flex flex-col px-5 pb-[7rem] gap-6">
        <MotionImage
          className="h-[13.625rem] mx-auto object-cover"
          src={DocumentNumberVisual}
          alt={"Vehicle registration document"}
        />

        <MotionText
          as="h1"
          className="text-[2.5rem] font-hubot font-black uppercase leading-none"
        >
          {t('expenses.documentInfo.title')}
        </MotionText>

        <MotionDiv className='flex flex-col gap-6 mb-1'>
          <MemoItem
            icon={<PiMagnifyingGlass className="h-6 w-6 text-zinc-900" />}
            title={t('expenses.documentInfo.documentName')} />
          <MemoItem
            icon={<PiCar className="h-6 w-6 text-zinc-900" />}
            title={t('expenses.documentInfo.documentNumber')} />
        </MotionDiv>

        <motion.div
          className="absolute bottom-0 -ml-5 px-5 pb-8 pt-8 w-full bg-linear-to-t from-white via-white to-transparent from-0% via-40% to-100%"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
          whileTap={{ scale: 0.98 }}
        >
          <Button onClick={() => navigate(-1)}>
            <span>{t('common.ok')}</span>
          </Button>
        </motion.div>
      </div>
    </div>
  );
};

const MemoItem = ({ icon, title }: { icon?: React.ReactNode; title: string }) => {
  return <MotionDiv className='flex flex-row items-center'>
    {icon && <div
      className="flex items-center justify-center min-w-12 min-h-12 rounded-full bg-zinc-100 mr-5">
      {icon}
    </div>
    }
    <div className='flex flex-col'>
      <p className='text-sm text-zinc-700'>{title}</p>
    </div>
  </MotionDiv>
}

export default ExpensesDocumentInfoPage;
